import IsBlocked from '@/core/components/IsBlocked/IsBlocked';

export default IsBlocked;
